import { useState, useEffect, useRef } from 'react';
import dayjs from 'dayjs';

interface CountdownProps {
    heldUntil: string;
    onExpire?: () => void;
}

const Countdown = ({ heldUntil, onExpire }: CountdownProps) => {
    const [timeLeft, setTimeLeft] = useState('');
    const hasExpiredRef = useRef(false);

    useEffect(() => {
        const calculateTimeLeft = () => {
            const heldUntilDate = dayjs(heldUntil);
            const now = dayjs();
            const diffInSeconds = heldUntilDate.diff(now, 'second');
            
            if (diffInSeconds <= 0) {
                if (!hasExpiredRef.current && onExpire) {
                    hasExpiredRef.current = true;
                    onExpire();
                }
                return 'Expired';
            }

            const minutes = Math.floor(diffInSeconds / 60);
            const seconds = diffInSeconds % 60;
            return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        };

        setTimeLeft(calculateTimeLeft());
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearInterval(timer);
    }, [heldUntil, onExpire]);

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <span style={{ fontSize: '0.8rem', color: '#666' }}>Time Remaining:</span>
            <span style={{ fontSize: '0.9rem', fontWeight: 600, color: '#d32f2f' }}>{timeLeft}</span>
        </div>
    );
};

export default Countdown;
